import React, { useMemo, useState } from 'react'
import './AlertModal.scss'
import { ReactComponent as CloseIcon } from '../../assets/images/CloseWhiteIcon.svg'
import { ReactComponent as TPOLogoNew } from '../../assets/images/WhiteLogo.svg'
import { digitalAppApi } from '../../../../store/services/digitalAppApi'


const AlertModal = () => {
  const [openAlert, setOpenAlert] = useState([]);
  const { data: sales, isLoading, isError } = digitalAppApi.useGetSalesQuery()
  
  const filteredSales = useMemo(() => {
    if (!isLoading) {
      const salesActive = sales?.filter((el) => el?.type == 'Alert' && el?.isActiveAlert)
      setOpenAlert(salesActive?.map((el) => el?._id))
      return salesActive
    }
  }, [sales])

  console.log(filteredSales);
  // const isAlert = currentSale?.type == 'Alert'

  return (<>
      {filteredSales?.length > 0 ? 
        filteredSales?.map((el, index) => (
          openAlert?.includes(el?._id) ?
          <div
            className='AlertModal'
            onClick={() => setOpenAlert(openAlert?.filter((id) => id !== el?._id))}
            key={index}
          >
            <div className='AlertModal__modal' onClick={(e) => e.stopPropagation()}>
              <div className='AlertModal__modal__header'>
                <div className='AlertModal__modal__header__label'>
                  <TPOLogoNew height={'31px'}/>
                  Tu Producto Online
                </div>
                <CloseIcon width={'15px'} height={'15px'} onClick={() => setOpenAlert(openAlert?.filter((id) => id !== el?._id))}/>
              </div>
              <div className='wrapper'>
                <div className='AlertModal__modal__preview'>
                  <img src={el?.imgLink} alt={el?.img} />
                  <div className='AlertModal__modal__info'>
                    <h1>{el?.name}</h1>
                    <p>{el?.description}</p>
                  </div>
                </div>
                
                <div dangerouslySetInnerHTML={{ __html: el?.text }} className='AlertModal__modal__text'>
                </div>
              </div>
            </div>
          </div> : null
        ))
        
      : null}
  </>
  )
}

export default AlertModal